import { render, staticRenderFns } from "./BlogPostContent.vue?vue&type=template&id=3c44dda2"
import script from "./BlogPostContent.vue?vue&type=script&lang=ts"
export * from "./BlogPostContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports